import { render, staticRenderFns } from "./MetricSelect.vue?vue&type=template&id=2807884a&"
import script from "./MetricSelect.vue?vue&type=script&lang=js&"
export * from "./MetricSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports